export default "__VITE_ASSET__lPYP7tXQ__"